// === Widget hero : sélecteur de taille + bouton acheter ===
  const merchPreview = document.querySelector('.merch-preview');
  const sizeBtns = document.querySelectorAll('.merch-size-btn');
  const buyBtn = document.querySelector('.merch-buy-btn');
  let selectedSize = null;

  // Récupère le prix depuis le data-price du widget (set par Liquid)
  const merchPrice = merchPreview ? (merchPreview.dataset.price || '35,00 €') : '35,00 €';
  const defaultBtnText = 'Ajouter · ' + merchPrice;

  // Reset initial du bouton avec le bon prix
  if (buyBtn) buyBtn.textContent = defaultBtnText;

  sizeBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const alreadyActive = btn.classList.contains('active');
      sizeBtns.forEach(b => b.classList.remove('active'));
      if (alreadyActive) {
        selectedSize = null;
        buyBtn.classList.remove('ready');
        buyBtn.classList.remove('added');
        buyBtn.textContent = defaultBtnText;
      } else {
        btn.classList.add('active');
        selectedSize = btn.dataset.size;
        buyBtn.classList.add('ready');
        buyBtn.classList.remove('added');
        buyBtn.textContent = defaultBtnText;
      }
    });
  });

  // === Compteur panier ===
  let cartCount = 0;
  const cartCountEl = document.querySelector('.cart-count');

  function refreshCart() {
    if (!cartCountEl) return;
    if (cartCount > 0) {
      cartCountEl.textContent = cartCount;
      cartCountEl.classList.add('has-items');
    } else {
      cartCountEl.textContent = '';
      cartCountEl.classList.remove('has-items');
    }
  }
  function updateCart(delta) {
    cartCount = Math.max(0, cartCount + delta);
    refreshCart();
    if (!cartCountEl) return;
    cartCountEl.classList.remove('bump');
    void cartCountEl.offsetWidth;
    cartCountEl.classList.add('bump');
  }
  // Init cart count depuis Shopify
  fetch('/cart.js').then(r => r.json()).then(c => {
    cartCount = c.item_count || 0;
    refreshCart();
  }).catch(() => refreshCart());

  // Met à jour le label de couleur sous les swatches selon l'état actif
  function updateColorLabel() {
    const label = document.querySelector('.merch-color-label');
    if (!label || !merchPreview) return;
    const active = merchPreview.dataset.active;
    if (active === 'noir') label.textContent = 'Noir';
    else if (active === 'orange') label.textContent = 'Orange';
    else label.textContent = '';
  }
  if (merchPreview) {
    updateColorLabel();
    new MutationObserver(updateColorLabel).observe(merchPreview, { attributes: true, attributeFilter: ['data-active'] });
  }

  if (buyBtn) {
    buyBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      // Vérifications : couleur ET taille requises
      const activeColor = merchPreview.dataset.active;
      if (!activeColor) {
        // Pas de couleur choisie : focus visuel sur les swatches
        const swatches = document.querySelector('.merch-swatches');
        if (swatches) {
          swatches.classList.remove('shake');
          void swatches.offsetWidth;
          swatches.classList.add('shake');
        }
        buyBtn.textContent = 'Choisir une couleur';
        setTimeout(() => { buyBtn.textContent = defaultBtnText; }, 1800);
        return;
      }
      if (!selectedSize) {
        const sizesEl = document.querySelector('.merch-sizes');
        if (sizesEl) {
          sizesEl.classList.remove('shake');
          void sizesEl.offsetWidth;
          sizesEl.classList.add('shake');
        }
        buyBtn.textContent = 'Choisir une taille';
        setTimeout(() => { buyBtn.textContent = defaultBtnText; }, 1800);
        return;
      }

      let variantId = null;

      // Matching couleur + taille (exact match sur les options du variant_title)
      try {
        const variants = JSON.parse(merchPreview.dataset.variants || '{}');
        const target = activeColor
          ? (activeColor + ' / ' + selectedSize).toLowerCase()
          : selectedSize.toLowerCase();
        // Match exact d'abord (ex: "noir / xs")
        if (variants[target]) {
          variantId = variants[target];
        } else {
          // Match précis : split par " / " et vérifie que chaque option correspond exactement
          for (const [key, id] of Object.entries(variants)) {
            const parts = key.split(' / ').map(p => p.trim());
            if (activeColor && selectedSize &&
                parts.includes(activeColor.toLowerCase()) &&
                parts.includes(selectedSize.toLowerCase())) {
              variantId = id;
              break;
            }
          }
        }
        // Fallback : première variante matchant juste la couleur
        if (!variantId && activeColor) {
          for (const [key, id] of Object.entries(variants)) {
            const parts = key.split(' / ').map(p => p.trim());
            if (parts.includes(activeColor.toLowerCase())) {
              variantId = id;
              break;
            }
          }
        }
        // Fallback ultime : première variante
        if (!variantId) {
          const firstKey = Object.keys(variants)[0];
          if (firstKey) variantId = variants[firstKey];
        }
      } catch (err) {
        console.warn('Variants parse error', err);
      }

      // Si pas de variante (pas de produit Shopify lié), animation visuelle seulement
      if (!variantId) {
        buyBtn.textContent = '✓ Ajouté';
        buyBtn.classList.add('added');
        updateCart(1);
        setTimeout(() => {
          buyBtn.classList.remove('added');
          buyBtn.textContent = defaultBtnText;
        }, 2000);
        return;
      }

      // Add to cart via Shopify AJAX API
      buyBtn.disabled = true;
      buyBtn.textContent = 'Ajout...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
      .then(r => r.json())
      .then(() => fetch('/cart.js').then(r => r.json()))
      .then(cart => {
        cartCount = cart.item_count || (cartCount + 1);
        refreshCart();
        buyBtn.textContent = '✓ Ajouté au panier';
        buyBtn.classList.add('added');
        // Ouvre le drawer panier
        if (window.ddkCart) { window.ddkCart.refresh(); window.ddkCart.open(); }
        setTimeout(() => {
          buyBtn.classList.remove('added');
          buyBtn.textContent = defaultBtnText;
          buyBtn.disabled = false;
        }, 2000);
      })
      .catch((err) => {
        console.error('Cart add error', err);
        buyBtn.textContent = 'Erreur — réessayer';
        setTimeout(() => {
          buyBtn.textContent = defaultBtnText;
          buyBtn.disabled = false;
        }, 2000);
      });
    });
  }

  // Click sur swatch = switcher la couleur affichée dans le widget
  document.querySelectorAll('.merch-swatch').forEach(sw => {
    sw.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const color = sw.dataset.color;
      const preview = sw.closest('.merch-preview');
      if (preview.dataset.active === color) {
        delete preview.dataset.active;
      } else {
        preview.dataset.active = color;
      }
      // Trigger pulse animation
      preview.classList.remove('clicked');
      void preview.offsetWidth; // force reflow pour relancer l'anim
      preview.classList.add('clicked');
      setTimeout(() => preview.classList.remove('clicked'), 550);
    });
    sw.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        sw.click();
      }
    });
  });

  // Click sur taille = activate (délégation pour survivre aux re-renders)
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.pc-size');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const card = btn.closest('.product-card');
    if (!card) return;
    card.querySelectorAll('.pc-size').forEach((b) => b.classList.remove('active'));
    btn.classList.add('active');
  });

  // Product card : add to cart
  document.querySelectorAll('.product-card').forEach((card) => {

    // Add to cart sur le bouton "Ajouter au panier"
    const addBtn = card.querySelector('.product-card-buy-btn');
    if (!addBtn) return;
    const initialText = addBtn.textContent;

    addBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      // Taille active
      const activeSize = card.querySelector('.pc-size.active');
      const size = activeSize ? activeSize.dataset.size : null;

      // Variante par défaut (Noir/Orange selon le bloc)
      const defaultVariant = (card.dataset.defaultVariant || '').toLowerCase();
      let variantId = null;

      try {
        // PRIORITÉ 1 : data-variants-list (matching robuste via les options Shopify)
        const vList = JSON.parse(card.dataset.variantsList || '[]');
        if (vList.length > 0 && defaultVariant && size) {
          const sizeNorm = size.toLowerCase();
          const matched = vList.find(v =>
            v.options.includes(defaultVariant) && v.options.includes(sizeNorm)
          );
          if (matched) variantId = matched.id;
        }
        // FALLBACK : ancien parsing via data-variants (titre)
        if (!variantId) {
          const variants = JSON.parse(card.dataset.variants || '{}');
          const target = defaultVariant && size
            ? (defaultVariant + ' / ' + size.toLowerCase())
            : null;
          if (target && variants[target]) {
            variantId = variants[target];
          } else {
            for (const [key, id] of Object.entries(variants)) {
              const parts = key.split(' / ').map(p => p.trim());
              if (defaultVariant && size &&
                  parts.includes(defaultVariant) &&
                  parts.includes(size.toLowerCase())) {
                variantId = id;
                break;
              }
            }
          }
          // Fallback couleur seule
          if (!variantId && defaultVariant) {
            for (const [key, id] of Object.entries(variants)) {
              const parts = key.split(' / ').map(p => p.trim());
              if (parts.includes(defaultVariant)) {
                variantId = id;
                break;
              }
            }
          }
          if (!variantId) {
            const firstKey = Object.keys(variants)[0];
            if (firstKey) variantId = variants[firstKey];
          }
        }
      } catch (err) {
        console.warn('Variants parse error (card)', err);
      }

      if (!variantId) {
        addBtn.textContent = '✓ Ajouté';
        setTimeout(() => { addBtn.textContent = initialText; }, 2000);
        return;
      }

      addBtn.disabled = true;
      addBtn.textContent = 'Ajout...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
      .then(r => r.json())
      .then(() => fetch('/cart.js').then(r => r.json()))
      .then(cart => {
        const cartCountEl = document.querySelector('.cart-count');
        if (cartCountEl) {
          cartCountEl.textContent = cart.item_count;
          cartCountEl.classList.add('has-items');
          cartCountEl.classList.remove('bump');
          void cartCountEl.offsetWidth;
          cartCountEl.classList.add('bump');
        }
        addBtn.textContent = '✓ Ajouté au panier';
        // Ouvre le drawer panier
        if (window.ddkCart) { window.ddkCart.refresh(); window.ddkCart.open(); }
        setTimeout(() => {
          addBtn.textContent = initialText;
          addBtn.disabled = false;
        }, 2000);
      })
      .catch((err) => {
        console.error('Cart add error (card)', err);
        addBtn.textContent = 'Erreur — réessayer';
        setTimeout(() => {
          addBtn.textContent = initialText;
          addBtn.disabled = false;
        }, 2000);
      });
    });
  });

  // Merch widget : empêcher le bouton "Voir porté" de déclencher le lien parent
  document.querySelectorAll('.merch-try').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
    });
  });

  // Header : fond noir blurré qui apparaît dès qu'on scrolle
  // Utilise IntersectionObserver sur un sentinel placé en haut de la page — plus fiable que scroll events
  (function() {
    const header = document.querySelector('.page-header');
    if (!header) return;

    // Crée un sentinel invisible au top de la page
    const sentinel = document.createElement('div');
    sentinel.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:10px;pointer-events:none;';
    document.body.prepend(sentinel);

    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) header.classList.remove('is-scrolled');
        else header.classList.add('is-scrolled');
      },
      { threshold: 0, rootMargin: '0px' }
    );
    io.observe(sentinel);
  })();

  // === Lightbox "Voir porté" cards collection (modal partagée + photos par card) ===
  (function() {
    const modal = document.querySelector('[data-card-lightbox]');
    if (!modal) return;
    const track = modal.querySelector('[data-card-track]');
    const counter = modal.querySelector('[data-card-counter]');
    const prevBtn = modal.querySelector('[data-card-prev]');
    const nextBtn = modal.querySelector('[data-card-next]');
    let current = 0;
    let total = 0;

    const renderSlides = (photos) => {
      track.innerHTML = '';
      photos.forEach((src, i) => {
        const slide = document.createElement('div');
        slide.className = 'try-lightbox-slide' + (i === 0 ? ' is-active' : '');
        slide.innerHTML = `<img src="${src}" alt="Voir porté ${i + 1}" loading="lazy">`;
        track.appendChild(slide);
      });
      total = photos.length;
      current = 0;
      update();
    };
    const update = () => {
      const slides = track.querySelectorAll('.try-lightbox-slide');
      slides.forEach((s, i) => s.classList.toggle('is-active', i === current));
      if (counter) counter.textContent = (current + 1) + ' / ' + total;
      if (prevBtn) prevBtn.toggleAttribute('disabled', total <= 1);
      if (nextBtn) nextBtn.toggleAttribute('disabled', total <= 1);
    };
    const go = (delta) => {
      current = (current + delta + total) % total;
      update();
    };
    const close = () => {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    };

    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-card-try-trigger]');
      if (!trigger) return;
      e.preventDefault();
      e.stopPropagation();
      const photos = [
        trigger.dataset.photo1,
        trigger.dataset.photo2,
        trigger.dataset.photo3,
        trigger.dataset.photo4
      ].filter(Boolean);
      if (photos.length === 0) return;
      renderSlides(photos);
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    });

    modal.querySelectorAll('[data-card-close]').forEach((el) => el.addEventListener('click', close));
    if (prevBtn) prevBtn.addEventListener('click', () => go(-1));
    if (nextBtn) nextBtn.addEventListener('click', () => go(1));
    document.addEventListener('keydown', (e) => {
      if (!modal.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') go(-1);
      else if (e.key === 'ArrowRight') go(1);
    });
  })();

  // === Lightbox "Voir porté" (hero widget) ===
  (function() {
    const trigger = document.querySelector('[data-try-trigger]');
    const modal = document.querySelector('[data-try-modal]');
    if (!trigger || !modal) return;

    const slides = modal.querySelectorAll('.try-lightbox-slide');
    const counter = modal.querySelector('[data-try-counter]');
    const prevBtn = modal.querySelector('[data-try-prev]');
    const nextBtn = modal.querySelector('[data-try-next]');
    const total = slides.length;
    let current = 0;

    const update = () => {
      slides.forEach((s, i) => s.classList.toggle('is-active', i === current));
      if (counter) counter.textContent = (current + 1) + ' / ' + total;
      if (prevBtn) prevBtn.toggleAttribute('disabled', total <= 1);
      if (nextBtn) nextBtn.toggleAttribute('disabled', total <= 1);
    };
    const go = (delta) => {
      current = (current + delta + total) % total;
      update();
    };

    const open = (e) => {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      current = 0;
      update();
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    };
    const close = () => {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    };

    trigger.addEventListener('click', open);
    trigger.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') open(e);
    });
    modal.querySelectorAll('[data-try-close]').forEach((el) => el.addEventListener('click', close));
    if (prevBtn) prevBtn.addEventListener('click', () => go(-1));
    if (nextBtn) nextBtn.addEventListener('click', () => go(1));

    document.addEventListener('keydown', (e) => {
      if (!modal.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') go(-1);
      else if (e.key === 'ArrowRight') go(1);
    });

    // Init affichage du compteur
    update();
  })();

  // Smooth scroll vers les ancres avec offset du header
  (function() {
    document.addEventListener('click', (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      const href = anchor.getAttribute('href');
      if (!href || href === '#') return;
      const target = document.querySelector(href);
      if (!target) return;
      e.preventDefault();
      const header = document.querySelector('.page-header');
      const headerH = header ? header.offsetHeight : 0;
      const top = target.getBoundingClientRect().top + window.scrollY - headerH - 8;
      window.scrollTo({ top, behavior: 'smooth' });
    });
  })();

  // Influencer : titres qui dérivent horizontalement au scroll (parallaxe douce)
  (function() {
    const section = document.querySelector('.influencer');
    if (!section) return;
    const florian = section.querySelector('.influencer-title:not(.influencer-title-2)');
    const dragdemon = section.querySelector('.influencer-title-2');
    if (!florian || !dragdemon) return;

    let ticking = false;

    function update() {
      const rect = section.getBoundingClientRect();
      const vh = window.innerHeight || document.documentElement.clientHeight;
      // progress -0.5 → +0.5 : -0.5 = section sous le viewport, 0 = centrée, +0.5 = au-dessus
      const center = rect.top + rect.height / 2;
      const progress = (center - vh / 2) / vh;
      const clamped = Math.max(-1, Math.min(1, progress));
      florian.style.setProperty('--scroll-x', `${-clamped * 80}px`);
      dragdemon.style.setProperty('--scroll-x-rev', `${clamped * 110}px`);
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  })();


  /* ============================================================
     CART DRAWER — gestion ouverture / fermeture / rendu items
     ============================================================ */
  (function () {
    const drawer = document.querySelector('[data-cart-drawer]');
    const backdrop = document.querySelector('[data-cart-backdrop]');
    const body = document.querySelector('[data-cart-body]');
    const footer = document.querySelector('[data-cart-footer]');
    const subtotalEl = document.querySelector('[data-cart-subtotal]');
    const countLabel = document.querySelector('[data-cart-count-label]');

    if (!drawer || !backdrop) return;

    function openDrawer() {
      drawer.classList.add('is-open');
      backdrop.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      loadCart();
    }
    function closeDrawer() {
      drawer.classList.remove('is-open');
      backdrop.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    // Triggers ouverture
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-cart-toggle]')) {
        e.preventDefault();
        openDrawer();
      }
      if (e.target.closest('[data-cart-close]')) {
        e.preventDefault();
        closeDrawer();
      }
    });
    backdrop.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });

    function formatMoney(cents) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }

    function renderCart(cart) {
      if (!body) return;
      const items = cart.items || [];

      // Compteur global header
      const cartCountEl = document.querySelector('.cart-count');
      if (cartCountEl) {
        if (cart.item_count > 0) {
          cartCountEl.textContent = cart.item_count;
          cartCountEl.classList.add('has-items');
        } else {
          cartCountEl.textContent = '';
          cartCountEl.classList.remove('has-items');
        }
      }
      if (countLabel) countLabel.textContent = cart.item_count || 0;

      if (items.length === 0) {
        body.innerHTML = `
          <div class="ddk-cart-empty" data-cart-empty>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">
              <path d="M5.5 8h13l-.8 11.5a1.8 1.8 0 0 1-1.8 1.7H8.1a1.8 1.8 0 0 1-1.8-1.7L5.5 8z"/>
              <path d="M9 8V6.2A3 3 0 0 1 12 3.2a3 3 0 0 1 3 3V8"/>
            </svg>
            <p>Ton panier est vide</p>
            <button type="button" class="ddk-cart-continue" data-cart-close>Continuer mes achats</button>
          </div>`;
        if (footer) footer.hidden = true;
        return;
      }

      body.innerHTML = items.map((item, idx) => {
        // Construit la ligne variante : "Noir · Taille M" (combine variant_title + properties)
        const parts = [];
        if (item.variant_title && item.variant_title !== 'Default Title') parts.push(item.variant_title);
        if (item.properties) {
          for (const [key, val] of Object.entries(item.properties)) {
            if (val && !key.startsWith('_')) parts.push(`${key} ${val}`);
          }
        }
        const variantLine = parts.join(' · ');
        return `
        <div class="ddk-cart-item" data-line="${idx + 1}" data-key="${item.key}">
          <div class="ddk-cart-item-img">
            ${item.image ? `<img src="${item.image}" alt="${item.title}" loading="lazy" />` : ''}
          </div>
          <div class="ddk-cart-item-info">
            <h3 class="ddk-cart-item-title">${item.product_title}</h3>
            ${variantLine ? `<span class="ddk-cart-item-variant">${variantLine}</span>` : ''}
            <div class="ddk-cart-item-controls">
              <div class="ddk-cart-qty">
                <button type="button" data-cart-qty-down aria-label="Diminuer">−</button>
                <span>${item.quantity}</span>
                <button type="button" data-cart-qty-up aria-label="Augmenter">+</button>
              </div>
              <button type="button" class="ddk-cart-item-remove" data-cart-remove aria-label="Supprimer">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M4 7 L20 7 M9 7 V5 a2 2 0 0 1 2-2 h2 a2 2 0 0 1 2 2 V7 M6 7 l1 13 a2 2 0 0 0 2 2 h6 a2 2 0 0 0 2-2 l1-13 M10 11 V18 M14 11 V18"/>
                </svg>
              </button>
            </div>
          </div>
          <div class="ddk-cart-item-price">${formatMoney(item.final_line_price)}</div>
        </div>
      `;
      }).join('');

      if (footer) footer.hidden = false;
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    }

    function loadCart() {
      fetch('/cart.js')
        .then(r => r.json())
        .then(renderCart)
        .catch(err => console.error('Cart load error:', err));
    }

    // Anti double-click : bloque toute nouvelle update tant que la précédente n'est pas finie
    let cartUpdating = false;
    function updateLine(key, quantity) {
      if (cartUpdating) return;
      cartUpdating = true;
      if (body) body.style.pointerEvents = 'none';
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
      .then(r => r.json())
      .then(renderCart)
      .catch(err => console.error('Cart update error:', err))
      .finally(() => {
        cartUpdating = false;
        if (body) body.style.pointerEvents = '';
      });
    }

    // Délégation : qty + / − / suppr
    // On utilise data-key (clé stable) au lieu de data-line (index qui shift après update)
    // Min qty = 1 : cliquer - à qty 1 ne fait rien (utilise trash pour retirer l'item)
    body && body.addEventListener('click', (e) => {
      const item = e.target.closest('.ddk-cart-item');
      if (!item) return;
      const key = item.dataset.key;
      if (!key) return;
      const qtySpan = item.querySelector('.ddk-cart-qty span');
      const currentQty = parseInt(qtySpan.textContent, 10);

      if (e.target.closest('[data-cart-qty-up]')) {
        updateLine(key, currentQty + 1);
      } else if (e.target.closest('[data-cart-qty-down]')) {
        if (currentQty > 1) {
          updateLine(key, currentQty - 1);
        }
      } else if (e.target.closest('[data-cart-remove]')) {
        updateLine(key, 0);
      }
    });

    // Init au chargement
    loadCart();

    // Expose pour les autres scripts qui ajoutent au panier
    window.ddkCart = {
      open: openDrawer,
      close: closeDrawer,
      refresh: loadCart
    };
  })();


  /* ============================================================
     BJ PRODUCT CARDS — Click swatch → switch couleur active
     ============================================================ */
  document.querySelectorAll('.bj-product-card .pc-swatch').forEach((sw) => {
    sw.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const card = sw.closest('.bj-product-card');
      if (!card) return;
      const color = sw.dataset.color;
      if (!color) return;
      card.dataset.active = color;
      card.dataset.defaultVariant = color;
    });
  });

  // BJ Product Cards : tap sur image (mobile) → flip face/dos
  document.querySelectorAll('.bj-product-card .product-card-img').forEach((imgArea) => {
    imgArea.addEventListener('click', (e) => {
      // Ignore les clicks sur swatches ou bouton "Voir porté"
      if (e.target.closest('.pc-swatch') || e.target.closest('.product-card-try')) return;
      const card = imgArea.closest('.bj-product-card');
      if (!card) return;
      const flipped = card.dataset.flipped === 'true';
      card.dataset.flipped = flipped ? 'false' : 'true';
    });
  });